// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"98ba200c","198":"40af44de","317":"af1cdd2a","401":"027e3e1e","453":"ab6544cf","565":"9a39bc80","861":"0abd7bdc"}[chunkId] + ".chunk.js";
};